export class ApiException {
  title = '';
  message = '';
  constructor(data) {
    this.title = data.title || data.status;
    this.status = data.status || data.status;
    this.message = data.detail || this.title || 'Unknown error';
    this.type = data.type;
    this.instance = data.instance;
    this.errors = data.errors;
  }
}